import { useTranslate } from 'react-admin';
import { OBJECT_STATUSES_ID_MAP } from '../../constants';

export const useObjectStatuses = () => {
	const t = useTranslate();

	const objectStatuses = [
		{
			id: OBJECT_STATUSES_ID_MAP.AVAILABLE,
			name: t('objects.page.statuses.available'),
			color: '#3e8e60'
		},
		{
			id: OBJECT_STATUSES_ID_MAP.RENTED,
			name: t('objects.page.statuses.rented'),
			color: '#d89a1b'
		},
		{
			id: OBJECT_STATUSES_ID_MAP.SOLD,
			name: t('objects.page.statuses.sold'),
			color: '#c74343'
		}
	];

	const getObjectStatus = (statusId: number) =>
		objectStatuses.find(s => s.id === statusId);

	return { objectStatuses, getObjectStatus };
};
